import React from 'react'

export default function StockOutItemFooterStyle({signed_in}) {
  let stockout_item_buttons = null
  if (signed_in !== 'admin') stockout_item_buttons = { stockout_fc: (signed_in.user_access.stockout_fc) ? 'block' : 'none' }
  else stockout_item_buttons = { stockout_fc: 'block' }

  return (
    <React.Fragment>
      <style jsx="true">
      {`
        #stock-out-item-footer-container {
          display: flex;
          padding: 3px;
        }
        .translist-button-container {
          flex: 1;
          display: flex;
          justify-content: flex-end;
        }
        .notification {
          font-size: 1rem;
          color: blue'
          padding: 0 7px;
          padding-bottom: 5px;
          margin: auto 0;
        }

        /** Stockout Item Footer Button **/
        #stockout-addnew-button,
        #stockout-item-edit-button,
        #stockout-item-post-button,
        #stockout-item-delete-button {
          display: ${stockout_item_buttons.stockout_fc}
        }
      `}
      </style>
    </React.Fragment>
  )
}
